import React from "react";
import "./Common.css";

// ── Page Header ─────────────────────────────────────────────
export const PageHeader: React.FC<{ title: string; subtitle?: string }> = ({ title, subtitle }) => (
  <div className="page-header">
    <h2 className="page-header__title">{title}</h2>
    {subtitle && <div className="page-header__subtitle">{subtitle}</div>}
  </div>
);

// ── Section Card ─────────────────────────────────────────────
export const SectionCard: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
  <div className="section-card">
    <div className="section-card__title">{title}</div>
    {children}
  </div>
);

// ── Loader ───────────────────────────────────────────────────
export const Loader: React.FC = () => (
  <div className="loader-wrapper">
    <div className="loader-text">Loading...</div>
  </div>
);

// ── Error Message ─────────────────────────────────────────────
export const ErrorMsg: React.FC<{ msg: string; onRetry?: () => void }> = ({ msg, onRetry }) => (
  <div className="error-state">
    <div className="error-state__message">{msg}</div>
    {onRetry && (
      <button onClick={onRetry} className="common-refresh-btn">
        Retry
      </button>
    )}
  </div>
);

// ── Refresh Button Style ──────────────────────────────────────
export const refreshBtnStyle: React.CSSProperties = {
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 6,
  padding: "8px 14px",
  cursor: "pointer",
  fontSize: 13,
  fontWeight: 500,
};
